<template>
  <div class="login-bg">
    <div class="container">
      <div class="row justify-content-center mb-4">
        <div class="col-lg-12 text-center">
          <h2
            v-bind:style="{
              color: '#fff',
              fontWeight: 'bold',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.9)',
            }"
          >
            {{ tagline }}
          </h2>
        </div>
        <div class="row justify-content-center">
          <div class="card rounded-lg">
            <b-row class="justify-content-center mt-2">
              <div class="logo text-center">
                <img src="/img/navbar/logo.png" alt="Logo" />
              </div>
            </b-row>
            <div class="card-body pl-5 pr-5">
              <h3 class="text-center mb-4">{{ $t("changePassword") }}</h3>
              <form class="theme-form" @submit.prevent="onSubmit">
                <div class="form-group">
                  <label for="otp" class="input-label mt-3">{{
                    $t("OTP")
                  }}</label>
                  <v-text-field
                    type="number"
                    id="otp"
                    v-model="otp"
                    :placeholder="$t('enterOTP')"
                    required
                    outlined
                    dense
                  ></v-text-field>

                  <div class="text-right">
                    <small v-if="resendTimer > 0">
                      {{ $t("resendOTP") }}
                      {{ Math.floor(resendTimer / 60) }}:{{
                        (resendTimer % 60).toString().padStart(2, "0")
                      }}
                    </small>
                    <a
                      href="#"
                      v-else
                      @click.prevent="resendOtp"
                      style="
                        font-size: 13px;
                        text-decoration: underline;
                        display: inline-block;
                      "
                    >
                      {{ $t("noOTPResend") }}
                    </a>
                  </div>
                  <label for="password" class="input-label">{{
                    $t("newPassword")
                  }}</label>
                  <v-text-field
                    v-model="password"
                    id="password"
                    :placeholder="$t('newPassword')"
                    :type="showPassword ? 'password' : 'text'"
                    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="togglePasswordVisibility"
                    class="password-field"
                    required
                    outlined
                    dense
                  ></v-text-field>
                  <label for="password" class="input-label">{{
                    $t("confirmNewPassword")
                  }}</label>
                  <v-text-field
                    v-model="confirmPassword"
                    id="password1"
                    :placeholder="$t('confirmNewPassword')"
                    :type="showPassword1 ? 'password' : 'text'"
                    :append-icon="showPassword1 ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="togglePasswordVisibility1"
                    class="password-field"
                    required
                    outlined
                    dense
                  ></v-text-field>
                </div>

                <div class="pt-4 form-group text-center">
                  <template v-if="!isLoading">
                    <b-button class="btn-primary" size="lg" type="submit">{{
                      $t("submit")
                    }}</b-button>
                  </template>
                  <template v-if="isLoading">
                    <b-spinner
                      v-for="i in 3"
                      :key="i"
                      class="mr-1"
                      small
                      label="Small Spinner"
                      type="grow"
                    ></b-spinner>
                  </template>
                </div>
              </form>
              <p class="pt-2" style="font-size: 13px">
                {{ $t("byContinue") }} {{ appName }}
                <router-link
                  to="/terms_conditions"
                  style="text-decoration: underline"
                  >{{ $t("accountDetails.terms") }}</router-link
                >
                {{ $t("ofUseand") }}
                <router-link
                  to="/privacy-policy"
                  style="text-decoration: underline"
                >
                  {{ $t("accountDetails.privacy") }}</router-link
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "/public/config.json";
export default {
  name: "newPassword",
  computed: {},
  data() {
    return {
      isLoading: false,
      password: null,
      otp: null,
      showPassword: false,
      showPassword1: false,
      confirmPassword: null,
      resetRef: null,
      resendTimer: 0,
      timerInterval: null,
      appName: config.appName,
      tagline: config.tagline,
    };
  },
  mounted() {
    const text = this.$route.params.text;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[6-9]\d{9}$/;
    if (emailRegex.test(text)) {
      this.startResendTimer(300);
    } else if (phoneRegex.test(text)) {
      this.startResendTimer(60);
    }
  },
  beforeDestroy() {
    clearInterval(this.timerInterval);
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    togglePasswordVisibility1() {
      this.showPassword1 = !this.showPassword1;
    },
    startResendTimer(duration) {
      this.resendTimer = duration;
      if (this.timerInterval) clearInterval(this.timerInterval);

      this.timerInterval = setInterval(() => {
        if (this.resendTimer > 0) {
          this.resendTimer--;
        } else {
          clearInterval(this.timerInterval);
          this.timerInterval = null;
        }
      }, 1000);
    },

    async resendOtp() {
      const text = this.$route.params.text;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phoneRegex = /^[6-9]\d{9}$/;

      const payload = {};
      let successMessage = "";

      if (emailRegex.test(text)) {
        payload.email = text;
        successMessage =
          "We've sent a Verification Code to your registered email address.";
      } else if (phoneRegex.test(text)) {
        payload.phone = text;
        successMessage =
          "We've sent a Verification Code to your registered mobile number.";
      } else {
        this.$swal({
          title: "Invalid Input",
          text: "Please enter a valid email address or a 10-digit mobile number to continue.",
          type: "warning",
          timer: 1500,
        });
        return;
      }

      try {
        await this.$store.dispatch("auth/forgotPasswordAction", payload);
        this.$swal({
          text: successMessage,
          type: "success",
        });
        this.startResendTimer(emailRegex.test(text) ? 300 : 60);
      } catch (err) {
        this.$swal({
          title: "Error",
          text:
            err.response?.data?.message ||
            "Failed to resend Verification Code. Please try again.",
          type: "error",
          timer: 1500,
        });
      }
    },
    async onSubmit() {
      if (this.password !== this.confirmPassword) {
        this.$swal({
          type: "error",
          title: "Error",
          text: "Passwords do not match. Please try again.",
        });
        return;
      }
      try {
        this.isLoading = true;
        const payload = {
          password: this.password,
          resetRef: this.$route.params.resetRefId,
          verificationCode: this.otp,
        };
        await this.$store.dispatch("auth/resetPasswordAction", payload);
        this.$swal({
          title: "Well Done !",
          text: "Password has been successfully updated",
          type: "success",
          timer: 1200,
        });
        setTimeout(() => {
          this.$router.push("/login-with");
        }, 1500);
      } catch (err) {
        this.$swal({
          title: "Error",
          text: err.response?.data?.message,
          type: "error",
          timer: 1200,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style scoped>
a {
  color: var(--primarycolor) !important;
  cursor: pointer;
}

form input {
  display: inline-block;
  width: 50px;
  height: 50px;
  text-align: center;
}
.password-field >>> .v-input__append-inner {
  cursor: pointer;
}
.password-field >>> .v-icon {
  background: none !important;
  padding: 0 !important;
  margin-right: 4px;
  color: #666;
}
@media (max-width: 768px) {
  h2 {
    font-size: 20px !important;
    padding: 0 10px;
  }
  .primary-btn {
    width: 100%;
    font-size: 16px;
    white-space: normal;
  }
  .card {
    margin: 20px auto;
    padding: 20px 15px;
  }

  .form-group {
    margin-bottom: 1rem;
  }

  .v-input input {
    font-size: 16px;
  }

  .checkbox p {
    font-size: 13px;
  }

  .primary-btn {
    font-size: 16px;
    padding: 0.75rem;
  }

  .logo img {
    width: 60px;
  }
}
.card {
  max-width: 500px;
  width: 100%;
  margin-left: auto;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
.login-bg {
  background-image: url("/img/login/login_bg_img.png");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 2rem 1rem;
}
.login-bg::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: url("/img/login/login_bg_img.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transform: scaleX(-1);
  z-index: -1;
  opacity: 0.4;
}
.modal-title-otp a:hover {
  text-decoration: underline !important;
}
.btn-primary {
  padding: 0.5rem 8rem;
}
.is-valid-phone {
  font-size: 14px;
  margin-top: 5px;
  margin-left: 9px;
  color: red;
}
.border {
  border: 1px solid #000;
}
.modal-title-otp {
  color: #579a70;
  cursor: pointer;
}
.loginBtn {
  box-sizing: border-box;
  position: relative;
  /* width: 13em;  - apply for fixed size */
  margin: 0.2em;
  padding: 0 15px 0 46px;
  border: none;
  text-align: left;
  line-height: 34px;
  white-space: nowrap;
  border-radius: 0.2em;
  font-size: 16px;
  color: #fff;
  width: 65%;
}
</style>
